const sessionMetricsConfig = {
  defaultWatchedLimit: 10,
  watchedLimitByLanguage: {
    'en-US': 10,
    'es-ES': 5,
  },
}

export { sessionMetricsConfig }
